import React from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n';
import { useMount } from 'react-use';
import take from 'lodash/take';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import { EVENT_CARD_SHARE_OPTIONS_PROPTYPE } from '@eb/eds-event-card';

import { LIST_CARD_TEMPLATE } from '../../../../../../constants';
import { SEARCH_SECTION } from '../../../../../../constants/analytics';

import { CardBucket } from '../../../../../../components/CardBucket';

export const EventSuggestions = (props) => {
    const {
        eventSuggestions,
        shareOptions,
        isAuthenticated,
        allEventsUrl,
        featureFlags,
        trackGAEventOnPageUnload,
        suggestionsLoading,
        trackGAEvent,
        searchEventSuggestionsAction,
        hasEventResults,
        bbox,
    } = props;

    useMount(() => {
        if (!hasEventResults && !isEmpty(bbox)) {
            searchEventSuggestionsAction(true);
        } else if (isEmpty(eventSuggestions)) {
            searchEventSuggestionsAction();
        }
    });

    if (isEmpty(eventSuggestions) && !suggestionsLoading) {
        return null;
    }

    const trackSeeMore = (_, linkUrl) => {
        props.trackGAEvent({
            action: 'ViewMore',
            label: linkUrl,
        });
    };

    let content = map(eventSuggestions, (event = {}) => ({
        ...event,
        section: SEARCH_SECTION,
        excludeExtraContent: true,
    }));

    content = take(content, 5);

    return (
        <div className="pivot-section eds-l-pad-bot-4">
            <CardBucket
                trackSeeMore={trackSeeMore}
                isLoading={suggestionsLoading}
                content={content}
                template={LIST_CARD_TEMPLATE}
                shareOptions={shareOptions}
                name={gettext('Popular events')}
                linkUrl={allEventsUrl}
                isAuthenticated={isAuthenticated}
                featureFlags={featureFlags}
                bucketKey="near_you"
                trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                trackGAEvent={trackGAEvent}
            />
        </div>
    );
};

EventSuggestions.propTypes = {
    shareOptions: EVENT_CARD_SHARE_OPTIONS_PROPTYPE.isRequired,
    isAuthenticated: PropTypes.bool,
    eventSuggestions: PropTypes.arrayOf(PropTypes.object),
    allEventsUrl: PropTypes.string,
    trackGAEventOnPageUnload: PropTypes.func,
    trackGAEvent: PropTypes.func,
    trackSeeMore: PropTypes.func,
};
